var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-light-danger font-weight-bolder mr-2",on:{"click":function($event){return _vm.$emit('onDelete')}}},[_c('i',{staticClass:"flaticon-delete"}),_vm._v(_vm._s(_vm.$t("DELETE"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }